<div class="personal-visit-action-bar">
  <div class="group">
    <div class="buttons">
      <sc-action-icon (click)="newPersonalVisitorVisit()"
        dictionaryKey="tmc.visit.overview.visitors.action.register.visitor.tooltip" [disabled]="!isAddEnabled"
        iconClass="fa-plus">
      </sc-action-icon>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon (click)="registerEntranceForVisitReservation()"
        dictionaryKey="tmc.visit.overview.visitors.action.register.visitreservation.tooltip"
        [disabled]="!isRegisterEnabled" iconClass="fa-user-check">
      </sc-action-icon>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon (click)="editPersonalVisit()" dictionaryKey="tmc.visit.overview.visitors.action.edit.tooltip"
        [disabled]="!isEditEnabled" iconClass="fa-edit">
      </sc-action-icon>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon (click)="deletePersonalVisit()" dictionaryKey="tmc.visit.overview.visitors.action.delete.tooltip"
        [disabled]="!isDeleteEnabled" iconClass="fa-trash">
      </sc-action-icon>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon (click)="leave()" dictionaryKey="tmc.visit.overview.visitors.action.leave.tooltip"
        [disabled]="!isLeaveEnabled" iconClass="fa-door-closed">
      </sc-action-icon>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon [disabled]="!isHandoutSupplementaryEquipmentEnabled"
        dictionaryKey="tmc.visit.overview.action.handoutSupplementaryEquipment"
        (click)="handoutSupplementaryEquipment()" iconClass="fa-upload">
      </sc-action-icon>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon [disabled]="!isTakeBackSupplementaryEquipmentEnabled"
        dictionaryKey="tmc.visit.overview.action.takeBackSupplementaryEquipment"
        (click)="takeBackSupplementaryEquipment()" iconClass="fa-download">
      </sc-action-icon>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon [disabled]="!resendInvitationEnabled"
        dictionaryKey="tmc.visit.overview.action.resendInvitationMail"
        (click)="takeBackSupplementaryEquipment()" iconClass="fa-envelope">
      </sc-action-icon>
      <ng-container *ngIf="isPrintVisitorIdentityCardConfigured">
        <sc-content-spacer></sc-content-spacer>
        <sc-action-icon [disabled]="!isPrintVisitorIdentityCardEnabled"
          dictionaryKey="tmc.visit.overview.action.printVisitorIdentityCard" (click)="printVisitorIdentityCard()"
          iconClass="fa-id-card"></sc-action-icon>
      </ng-container>
      <ng-container *ngIf="!isPrintVisitorIdentityCardConfigured">
        <sc-content-spacer></sc-content-spacer>
        <sc-action-icon [disabled]="!isCreateVisitorIdentityCardPDFEnabled"
          dictionaryKey="tmc.visit.overview.action.createVisitorIdentityCardPDF"
          (click)="createVisitorIdentityCardPDF()" iconClass="fa-id-badge"></sc-action-icon>
      </ng-container>
      <sc-content-spacer></sc-content-spacer>
      <sc-action-icon (click)="emergencyCall()" [disabled]="!isEmergencyCallEnabled"
        dictionaryKey="tmc.visit.overview.action.emergencyCall" iconClass="fa-siren-on"></sc-action-icon>
    </div>
  </div>
</div>
